<template lang="html">
  <div id="loged-home" v-if="user.userLoggedIn || doctor.doctorLoggedIn">
    <div class="loged-home">
      <div class="col-md-10" v-if="user.userLoggedIn">
        <div class="row">
          <div class="col-md-6">
            <div class="buttons back-menu text-left"><a @click="$router.go(-1)"><img class="img-responsive img-circle" src="../assets/img/icons/back-button.svg" alt="Back Button">{{page}}</a></div>
          </div>
          <div class="col-md-6 text-right user">
            {{user.name + ' ' + user.lastName}}
            <span @click='showUserLinks'>
              <span v-if="user.thumb">
                <img class="img-responsive img-circle" v-bind:src="user.thumb" :alt="translation.profile.altImage + user.name">
              </span>
              <span v-else>
                <img  class="uploading-image img-circle img-responsive" src="../assets/img/user-home-icon-default.svg" alt="Default Image">
              </span>
            </span>
            <div v-if="userNav">
              <div class="account row">
                <div class="col-xs-6">
                  <router-link class="profile" to="/preview-user-profile">{{translation.users.profile}}</router-link>
                </div>
                <div class="col-xs-6">
                  <router-link class="logout" to="/logout">{{translation.header.logout}}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
        <div class="col-md-10" v-else-if="doctor.doctorLoggedIn">
          <div class="row">
            <div class="col-md-6">
            <div class="buttons back-menu text-left"><a @click="$router.go(-1)"><img class="img-responsive img-circle" src="../assets/img/icons/back-button.svg" alt="Back Button">{{page}}</a></div>
            </div>
            <div class="col-md-6 text-right user" >
              {{doctor.name + ' ' + doctor.doctorLastName}}
              <span @click='showUserLinks'>
                <span v-if="doctor.thumb">
                  <img class="img-responsive img-circle" v-bind:src="doctor.thumb" :alt="translation.profile.altImage + doctor.name">
                </span>
                <span v-else>
                  <img  class="uploading-image img-circle img-responsive" src="../assets/img/doctor-home-icon-default.svg" alt="Default Image">
                </span>
              </span>
              <div v-if="userNav">
                <div class="account row">
                  <div class="col-xs-6">
                    <router-link class="profile" to="/preview-doctor-profile">{{translation.users.profile}}</router-link>
                  </div>
                  <div class="col-xs-6">
                    <router-link class="logout" to="/doctor-logout">{{translation.header.logout}}</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
    </div>
    <div class="loged-mobile-home nav">
      <div v-if="user.userLoggedIn" class="col-xs-12 text-left">
        <div class="menu-button row">
          <div class="buttons col-sm-4 col-xs-4 text-left"><a @click="$router.go(-1)"><img class="img-responsive img-circle" src="../assets/img/icons/back-button.svg" alt="Back Button"></a></div>
          <div class="col-sm-4 col-xs-4 text-center"> <router-link :to="{ name: 'user-home-page', params: { lang: lang }}"><img class="img-responsive logo-loged" src="../assets/img/icons/128x128.png" alt="Logo"></router-link></div>
          <div class="buttons col-sm-4 col-xs-4 text-right">
              <span class="text-right user">
                <span @click='showUserLinks'>
                  <span v-if="user.thumb">
                    <img class="img-responsive user-image img-circle" v-bind:src="user.thumb">
                  </span>
                  <span v-else>
                    <img  class="uploading-image img-responsive user-image img-circle" src="../assets/img/user-home-icon-default.svg" alt="Default Image">
                  </span>
                </span>
                <span v-if="userNav">
                  <div class="account text-center row">
                    <div class="col-xs-6">
                      <router-link class="profile" to="/preview-user-profile">{{translation.users.profile}}</router-link>
                    </div>
                    <div class="col-xs-6">
                      <router-link class="logout" :to="{name:'logout', params:{ lang: 'bg'}}">{{translation.header.logout}}</router-link>
                    </div>
                  </div>
                </span>
              </span>
          </div>
        </div>
      </div>
      <div v-if="doctor.doctorLoggedIn" class="col-xs-12 text-left">
        <div class="menu-button row">
          <div class="buttons col-sm-4 col-xs-4 text-left"><a @click="$router.go(-1)"><img class="img-responsive img-circle" src="../assets/img/icons/back-button.svg" alt="Back Button"></a></div>
          <div class="col-sm-4 col-xs-4"> <router-link :to="{ name: 'doctor-home', params: { lang: lang }}"><img class="img-responsive logo-loged" src="../assets/img/icons/128x128.png" alt="Logo"></router-link></div>
          <div class="buttons col-sm-4 col-xs-4 text-right">
              <span class="text-right user">
                <span @click='showUserLinks'>
                  <span v-if="user.thumb">
                    <img class="img-responsive user-image img-circle" v-bind:src="user.thumb">
                  </span>
                  <span v-else>
                    <img  class="uploading-image img-responsive user-image img-circle" src="../assets/img/user-home-icon-default.svg" alt="Default Image">
                  </span>
                </span>
                <span v-if="doctorNav">
                  <div class="account text-center row">
                    <div class="col-xs-6">
                      <router-link class="profile" to="/preview-doctor-profile">{{translation.users.profile}}</router-link>
                    </div>
                    <div class="col-xs-6">
                      <router-link class="logout" to="/doctor-logout">{{translation.header.logout}}</router-link>
                    </div>
                  </div>
                </span>
              </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'LogedHeader',
  data() {
    return {
      translation: null,
      loader: false,
      user: [],
      page: '',
      nav: false,
      showPets: false,
      showVets: false,
      pets:'',
      userNav: false,
      doctorNav: false,
      fixedHeader: false,
      doctor: [],
      defaultLang: '',
      lang: window.lang
    }
  },
  watch:{
    $route (to, from){
        this.nav = false;
        this.userNav = false;
        this.doctorNav = false;
        this.page = window.pageHeader;
    }
  },
  created(){
    if (localStorage.getItem('language')) {
      this.defaultLang = localStorage.getItem('language');
    }else {
      this.defaultLang = 'bg_BG';
    }
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    this.getUser();
    this.getDoctor();
    this.getPets();
    this.$bus.$on('logged', () => {
      this.getUser();
    });
    this.$bus.$on('doctorLoggedIn', () => {
      this.getDoctor();
    });
    this.$bus.$on('createPet', () => {
      this.getPets();
    });
    this.$bus.$on('changeThumb', () => {
      this.getPets();
    });
    this.$bus.$on('userThumb', () => {
      this.getUserThumb();
    });
    this.$bus.$on('doctorThumb', () => {
      this.getDoctorThumb();
    });
  },
  methods:{
    getPets: function(){
      this.loader = true;
      var self = this;
      axios.get('get-pets')
      .then(function (response){
          self.loader = false;
          self.pets = response.data.result
      })
      .catch(err => console.error(err))
    },
    showUserLinks: function(){
      if (this.userNav) {
        this.userNav = !this.userNav;
      }else {
        this.userNav = !this.userNav;
      }
      if (this.doctorNav) {
        this.doctorNav = !this.doctorNav;
      }else {
        this.doctorNav = !this.doctorNav;
      }
    },
    showPetsMethod: function(){
      if (this.showPets) {
        this.showPets = !this.showPets;
      }else {
        this.showPets = !this.showPets;
      }
    },
    showVetsMethod: function(){
      if (this.showVets) {
        this.showVets = !this.showVets;
      }else {
        this.showVets = !this.showVets;
      }
    },
    showNav: function(e){
      this.nav = true;
    },
    hideNav: function(e){
      this.nav = false;
    },
    getUser: function(){
      this.loader = true;
      var self = this;
      axios.get('get-user')
      .then(function (response){
          self.loader = false;
          self.user = '';
          if(response.data.result){
            self.user = response.data.result;
          }
          if (response.data.success) {
            if (self.user || self.user.lenght) {
              if (self.user.userLoggedIn) {
                localStorage.setItem('userLoggedIn', response.data.result.userLoggedIn);
                self.$bus.$emit('sideBar', true);
                if (response.data.result.userLanguage) {
                  localStorage.setItem('language', response.data.result.userLanguage);
                  self.$bus.$emit('language',true)
                }
                if (self.$route.name == 'home') {
                  self.$router.push({ name: 'user-home-page', params: { lang: window.lang } })
                }
              }else {
                localStorage.removeItem('userLoggedIn');
              }
            }
          }
      })
      .catch(err => console.error(err))
    },
    getUserThumb: function(){
      this.loader = true;
      var self = this;
      axios.get('get-user')
      .then(function (response){
          self.loader = false;
          self.user = response.data.result;
      })
      .catch(err => console.error(err))
    },
    getDoctor: function(){
      this.loader = true;
      var self = this;
      axios.get('get-doctor')
      .then(function (response){
          self.loader = false;
          self.doctor = '';
          if(response.data.result){
            self.doctor = response.data.result;
          }
          if (response.data.success) {
            if (self.doctor || self.doctor.lenght) {
              if (self.doctor.doctorLoggedIn) {
                // self.$router.push({ name: 'doctor-home', params: { lang: window.lang } })
                localStorage.setItem('doctorLoggedIn', response.data.result.doctorLoggedIn);
                self.$bus.$emit('sideBar', true)
                if (response.data.result.doctorLanguage) {
                  localStorage.setItem('language', response.data.result.doctorLanguage);
                  self.$bus.$emit('language',true)
                }
                if (self.$route.name == 'home') {
                  self.$router.push({ name: 'doctor-home', params: { lang: window.lang } })
                }
              }else {
                localStorage.removeItem('doctorLoggedIn');
              }
            }
          }
      })
      .catch(err => console.error(err))
    },
    getDoctorThumb: function(){
      this.loader = true;
      var self = this;
      axios.get('get-doctor')
      .then(function (response){
          self.loader = false;
          self.doctor = response.data.result;
      })
      .catch(err => console.error(err))
    }
  }
}
</script>
<style lang="css">
@font-face {
  font-family: 'Montserrat-Black';
  src: url("../assets/fonts/Montserrat-Black.woff") format("woff");
  font-display: swap;
}
#loged-home {
  font-family: "Montserrat-Black",sans-serif;
  color: #3057B0;
}
#loged-home a{
  text-decoration: none;
  color: #3057B0;
}
#loged-home a:hover{
  text-decoration: none;
  color: #3057B0;
}
#loged-home .account{
  margin: 0 auto;
  padding: 1em;
  border-radius: 5em;
  margin-top: 1em;
  background: #3057B0;
  width: 23em;
  text-align: left;
  font-weight: bold;
  position: absolute;
  right: 0;
}
#loged-home .account a {
  display: inline-block;
  width: 100%;
}
#loged-home .account .profile{
  border-radius: 5em;
  background-color: #fff;
  text-align: center;
  padding: .5em;
}
#loged-home .sidebar-btn{
  margin: 1em;
}
#loged-home .account .logout{
  border-radius: 5em;
  border: 2px solid #fff;
  color: #fff;
  text-align: center;
  padding: .5em;
  padding-left: 1em;
  padding-right: 1em;
}
.back-menu {
  cursor: pointer;
}
.back-menu img{
  margin-right: .5em;
}
#loged-home .loged-mobile-home{
  display: none;
}
 #loged-home .nav-container {
  background-color:  #3057B0!important;
  color: #fff;
}
 #loged-home .nav-container a{
   color: #fff;
 }
 .loged-mobile-home .menu-button img {

 }
 @media (width: 1024px) {
   .buttons img {
     width: 5em;
   }
 }
@media (max-width: 1024px) {
  #loged-home .nav .hideNav{
    padding: 10px;
    padding-left: 25px;
    padding-top: 6px;
    height: 6em;
    margin-bottom: 3em;
  }
  #loged-home .menu-button .user-image{
    width: 4em;
  }
  #loged-home .buttons img {
    width: 4em;
  }
  #loged-home .menu-button .logo-loged{
    width: 4em;
  }
  #loged-home .account {
    width: 18em;
    font-size: .9em;
}
  #loged-home .hideNav {
    background: #fff;
  }
  #loged-home .loged-home{
    display: none;
  }
  #loged-home{
    position: relative!important;
    width: 100%!important;
    height: 100%!important;
  }
  #loged-home .loged-mobile-home{
    display: block;
  }
  #app #logo-home{
    font-size: 1em;
  }
  #logo-home .nav-container{
    margin-left: 1em;
    background: #3057B0;
    color: #fff;
  }

}
@media (max-width: 768px) {
  #loged-home{
    position: relative!important;
    width: 100%!important;
    height: 100%!important;
    padding: 0;
    padding-top: 0;
  }
}
</style>
